import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n.use(LanguageDetector)
    .use(initReactI18next) // bind react-i18next to the instance
    .init({
        // init with resources
        resources: {
            en: {
                translations: {
                    // TODO import the data.json translation file
                    "Select Your Plan": "Select Your Plan",
                    Inbound: "Inbound",
                    Outbound: "Outbound",
                    "Inbound + Outbound": "Inbound + Outbound",
                    "signup.error.bad_request":
                        "There was a problem signing you up, please complete your form and try again.",
                    "signup.error.conflict":
                        "Your email is already in use. For existing customers signing up for a new product, please use a different email.",
                    "signup.error.not_found":
                        "We couldn't find the plans you're signing up for, please specify valid plans",
                    "signup.error.credit_card":
                        "Your credit card information is invalid, please use valid credit card information",
                    "signup.error.credit_card_declined":
                        "There was an error processing your credit card. Your account has not been created. Please try again, or create a support ticket at https://mailchannels.zendesk.com/hc/en-us/requests/new.",
                    "signup.error.unknown_error":
                        "Sorry we ran into a problem and couldn't sign you up at the moment. Please try once more and if the problem persists contact support@mailchannels.com, providing the email address that was used to sign up.",
                    "signup.error.post_signup":
                        "We ran into a problem completing your signup. Your credit card has been charged but your setup is only done partially. Contact support at https://mailchannels.zendesk.com/hc/en-us/requests/new to complete the rest of signup.",
                    "signup.error.activation_email_send":
                        "We ran into an error sending your account activation email. Your credit card has been charged and your account is partially configured. Please create a support ticket at https://mailchannels.zendesk.com/hc/en-us/requests/new to complete the rest of the signup.",
                    "signup.error.fraud":
                        "We couldn't complete your signup because it was flagged as potentially fraudulent. Please contact support if you believe this is a mistake.",
                    "signup.error.onetime_token":
                        "There was a problem signing you up, please contact Support at: support@mailchannels.com",
                },
            },
        },
        fallbackLng: "en",
        debug: true,

        // have a common namespace used around the full app
        ns: ["translations"],
        defaultNS: "translations",

        keySeparator: false, // we use content as keys

        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ",",
        },

        react: {
            wait: true,
        },
    });

export default i18n;
